import { FunctionComponent } from 'react';
import classNames from 'classnames';
import * as Icons from './assets';
import * as styles from './DeliveryUpdateListItem.module.scss';

// TODO: these svg icons should be replaced with their FA6 counterparts once we update our FA version
const STATUS_ICONS = {
  delivered: Icons.CheckIcon,
  outForDelivery: Icons.PersonCarryBoxIcon,
  inTransit: Icons.TruckIcon,
  packageShipped: Icons.CubeIcon,
  processingShipment: Icons.ClockIcon,
  error: Icons.ExclamationIcon,
};

export type StatusType =
  | 'delivered'
  | 'outForDelivery'
  | 'inTransit'
  | 'packageShipped'
  | 'processingShipment'
  | 'error';

export type DeliveryUpdateListItemProps = {
  index: number;
  statusName: StatusType;
  description: string;
  location: string;
  subtext: string;
};

export const DeliveryUpdateListItem: FunctionComponent<DeliveryUpdateListItemProps> = ({
  index,
  statusName,
  description,
  location,
  subtext,
}) => {
  const IconComponent = STATUS_ICONS[statusName];

  return (
    <li key={`status-${index}`} data-testid="status-item">
      <div className={styles.statusIconContainer}>
        <div
          className={classNames(
            styles.statusIcon,
            index === 0 ? styles[statusName] : styles.processingShipment,
          )}
          data-testid="icon-container"
        >
          <IconComponent data-testid={statusName} />
        </div>
      </div>
      <div className={styles.statusText}>
        <div className={styles.statusDescription}>{description}</div>
        <div>{location}</div>
        <div>{subtext}</div>
      </div>
    </li>
  );
};
